import React, { useEffect, useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import "bootstrap/dist/css/bootstrap.min.css";
import { Col, Row, Container } from "react-bootstrap";
import { motion } from "framer-motion";

function CukPage() {
  const [isVisible, setIsVisible] = useState(false);

  // Effect for animation on scroll
  useEffect(() => {
    const handleScroll = () => {
      const contentSection = document.getElementById('cuk-content');
      if (contentSection) {
        const contentPosition = contentSection.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
        
        if (contentPosition < windowHeight * 0.75) {
          setIsVisible(true);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    // Run once on initial load
    setTimeout(handleScroll, 100);
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Array of image objects
  const images = [
    { url: "https://firebasestorage.googleapis.com/v0/b/olewintechsolutions-cdfe3.appspot.com/o/CUK_ICEEA-2025%2FIMG_2277%202.jpg?alt=media&token=07a32710-e7f8-41f1-9f28-3e034ba2fdf7" },
        { url: "https://firebasestorage.googleapis.com/v0/b/olewintechsolutions-cdfe3.appspot.com/o/olewinacademy%2Fcukconference%2FIMG_3788.JPG?alt=media&token=869473bf-45c9-4910-9d09-c3885b52bd1e" },
            { url: "https://firebasestorage.googleapis.com/v0/b/olewintechsolutions-cdfe3.appspot.com/o/olewinacademy%2Fcukconference%2FIMG_4257.JPG?alt=media&token=846e61e0-3839-43fa-baa6-c57e2532e925" },
            {url:"https://firebasestorage.googleapis.com/v0/b/olewintechsolutions-cdfe3.appspot.com/o/olewinacademy%2Fcukconference%2FIMG_4568.JPG?alt=media&token=677e0a9c-93e5-4da9-aacf-313a3580c4b6"},
{url:"https://firebasestorage.googleapis.com/v0/b/olewintechsolutions-cdfe3.appspot.com/o/olewinacademy%2Fcukconference%2FIMG_4570.JPG?alt=media&token=3580ca31-345f-4bd6-b7c9-ef5caf011339"},
    { url: "https://firebasestorage.googleapis.com/v0/b/olewintechsolutions-cdfe3.appspot.com/o/olewinacademy%2Fcukconference%2FIMG_4507.JPG?alt=media&token=292ab89f-4d58-4f9b-9d37-4a24c332f75f" },
    { url: "https://firebasestorage.googleapis.com/v0/b/olewintechsolutions-cdfe3.appspot.com/o/olewinacademy%2Fcukconference%2FIMG_3798.JPG?alt=media&token=b0639609-d363-4e6a-b402-27314a57140b" },
    { url: "https://firebasestorage.googleapis.com/v0/b/olewintechsolutions-cdfe3.appspot.com/o/olewinacademy%2Fcukconference%2FIMG_3799.JPG?alt=media&token=038c795e-095e-4fe6-bbcd-81816049df55" },
        { url: "https://firebasestorage.googleapis.com/v0/b/olewintechsolutions-cdfe3.appspot.com/o/olewinacademy%2Fcukconference%2FIMG_4509.JPG?alt=media&token=74ecfaf9-21db-453b-b938-a4f2a2489baa" },
{url:"https://firebasestorage.googleapis.com/v0/b/olewintechsolutions-cdfe3.appspot.com/o/olewinacademy%2Fcukconference%2FIMG_4516.JPG?alt=media&token=f8cae5df-6fed-4fe0-86cc-c8c61d6ced43"},
{url:"https://firebasestorage.googleapis.com/v0/b/olewintechsolutions-cdfe3.appspot.com/o/olewinacademy%2Fcukconference%2FIMG_4541.JPG?alt=media&token=5231b1e8-94b8-40f2-a0ff-720347942880"},
{url:"https://firebasestorage.googleapis.com/v0/b/olewintechsolutions-cdfe3.appspot.com/o/olewinacademy%2Fcukconference%2FIMG_4546.JPG?alt=media&token=495002dc-db4d-4575-a1a0-6985492be6b8"},
{url:"https://firebasestorage.googleapis.com/v0/b/olewintechsolutions-cdfe3.appspot.com/o/olewinacademy%2Fcukconference%2FIMG_4560.JPG?alt=media&token=4c34a08e-c013-4ca6-9091-b6f2f6ef3eb7"},
{url:"https://firebasestorage.googleapis.com/v0/b/olewintechsolutions-cdfe3.appspot.com/o/olewinacademy%2Fcukconference%2FIMG_5822.JPG?alt=media&token=f0e9d94e-e446-4669-81de-1e705abf9ef8"},
{url:"https://firebasestorage.googleapis.com/v0/b/olewintechsolutions-cdfe3.appspot.com/o/olewinacademy%2Fcukconference%2FIMG_5825.JPG?alt=media&token=0fef75a4-b196-4be4-beda-8ebe38ff3857"},
{url:"https://firebasestorage.googleapis.com/v0/b/olewintechsolutions-cdfe3.appspot.com/o/olewinacademy%2Fcukconference%2FIMG_5858.JPG?alt=media&token=788fca63-9b88-47cf-85c9-e21c10c25961"},
    { url: "https://firebasestorage.googleapis.com/v0/b/olewintechsolutions-cdfe3.appspot.com/o/CUK_ICEEA-2025%2FIMG_4539.JPG?alt=media&token=fd511a6e-29ab-4ae7-945a-c3b358bb79a2" },
    { url: "https://firebasestorage.googleapis.com/v0/b/olewintechsolutions-cdfe3.appspot.com/o/CUK_ICEEA-2025%2FIMG_4266%202.JPG?alt=media&token=c079696e-53e7-424c-aeb5-3b6860fa95fb" },
    { url: "https://firebasestorage.googleapis.com/v0/b/olewintechsolutions-cdfe3.appspot.com/o/CUK_ICEEA-2025%2FIMG_2277.jpg?alt=media&token=33d27732-962b-4495-9f82-ddf595079679" },
    { url: "https://firebasestorage.googleapis.com/v0/b/olewintechsolutions-cdfe3.appspot.com/o/CUK_ICEEA-2025%2FIMG_2335.jpg?alt=media&token=f4320311-a93f-4ad5-862b-01f955cf8175" },
    { url: "https://firebasestorage.googleapis.com/v0/b/olewintechsolutions-cdfe3.appspot.com/o/CUK_ICEEA-2025%2FIMG_3662.JPG?alt=media&token=5d9e0a8f-2f51-49e2-9363-b3ed5dd24f18" },
    { url: "https://firebasestorage.googleapis.com/v0/b/olewintechsolutions-cdfe3.appspot.com/o/CUK_ICEEA-2025%2FIMG_4332%202.HEIC?alt=media&token=f940a44d-84ac-46c8-b6a7-38bff1180ebf" },
    { url: "https://firebasestorage.googleapis.com/v0/b/olewintechsolutions-cdfe3.appspot.com/o/CUK_ICEEA-2025%2FIMG_4332.png?alt=media&token=d6db9fe6-9e4b-4e40-b467-738d72d0a7ad" },
    { url: "https://firebasestorage.googleapis.com/v0/b/olewintechsolutions-cdfe3.appspot.com/o/CUK_ICEEA-2025%2Fad879dac-2828-4529-9e9a-5a499b9d2ee2.png?alt=media&token=8f728fa3-afae-4bb0-ad88-24659470241d" },
    { url: "https://firebasestorage.googleapis.com/v0/b/olewintechsolutions-cdfe3.appspot.com/o/olewinacademy%2Fcukconference%2FIMG_3762.JPG?alt=media&token=a5955f51-bc6c-4524-ad50-f92699f96588" },
    { url: "https://firebasestorage.googleapis.com/v0/b/olewintechsolutions-cdfe3.appspot.com/o/olewinacademy%2Fcukconference%2FIMG_3771.JPG?alt=media&token=8492ea23-5aa7-4921-b6da-25e966d0ab0f" },
    { url: "https://firebasestorage.googleapis.com/v0/b/olewintechsolutions-cdfe3.appspot.com/o/olewinacademy%2Fcukconference%2FIMG_3800.JPG?alt=media&token=8aeedb69-4b49-4af2-aa8a-244e9b424e69" },
    { url: "https://firebasestorage.googleapis.com/v0/b/olewintechsolutions-cdfe3.appspot.com/o/olewinacademy%2Fcukconference%2FIMG_4140.JPG?alt=media&token=3ec2b6bf-b596-400c-93a4-4aac7b6103cf" },
    { url: "https://firebasestorage.googleapis.com/v0/b/olewintechsolutions-cdfe3.appspot.com/o/olewinacademy%2Fcukconference%2FIMG_4398.JPG?alt=media&token=8d4eb6b1-0307-4c76-a9d0-8f1971bbd69f" },
    { url: "https://firebasestorage.googleapis.com/v0/b/olewintechsolutions-cdfe3.appspot.com/o/olewinacademy%2Fcukconference%2FIMG_4405.JPG?alt=media&token=8d559973-a3ef-451c-b09d-4815e74fb3c4" },
        { url: "https://firebasestorage.googleapis.com/v0/b/olewintechsolutions-cdfe3.appspot.com/o/olewinacademy%2Fcukconference%2FIMG_7199.JPG?alt=media&token=7c0d5f45-06e1-4c43-9494-c62ef73a83b0" },
    { url: "https://firebasestorage.googleapis.com/v0/b/olewintechsolutions-cdfe3.appspot.com/o/olewinacademy%2Fcukconference%2FIMG_6092.JPG?alt=media&token=1c9825fd-8a26-41c6-8697-294e1eb21d61" },
   
  ];


  // Animation variants
  const fadeInUp = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  // Simple custom styles
  const customStyles = `
    .main-container {
      max-height: 100vh;
      overflow: hidden;
      margin: 15px auto;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      border-radius: 8px;
      background-color: #fff;
    }
    
    .content-card {
      height: 100%;
      padding: 15px 20px;
      overflow-y: auto;
      border-right: 1px solid #e9ecef;
    }
    
    .carousel-container {
      height: 80vh;
      padding: 15px;
    }
    
    .carousel-indicators button {
      width: 8px !important;
      height: 8px !important;
      border-radius: 50% !important;
      background-color: #adb5bd !important;
      margin: 0 4px !important;
    }
    
    .carousel-indicators .active {
      background-color: #007bff !important;
    }
    
    .event-title {
      color: #0056b3;
      margin-bottom: 10px;
      font-size: 1.4rem;
      font-weight: 600;
    }
    
    .event-date {
      color: #dc3545;
      font-weight: 600;
      margin-bottom: 10px;
    }
    
    .event-sponsor {
      margin-bottom: 15px;
    }
    
    .divider {
      height: 1px;
      background-color: #e9ecef;
      margin: 15px 0;
    }
    
    .logo-container {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 20px;
      margin: 20px 0;
    }

    /* Fix for carousel image sizing */
    .carousel, .carousel-inner, .carousel-item {
      height: 100%;
    }
    
    .carousel-item img {
      height: calc(80vh - 70px);
      object-fit: contain;
      width: 100%;
    }
    
    @media (max-width: 768px) {
      .main-container {
        max-height: none;
      }
      
      .content-card {
        border-right: none;
        border-bottom: 1px solid #e9ecef;
      }
      
      .carousel-container {
        height: 50vh;
      }
      
      .carousel-item img {
        height: calc(50vh - 50px);
      }
    }
  `;

  return (
    <Container fluid className=" my-5 py-4">
      {/* Add custom styles */}
      <style>{customStyles}</style>
      
     

      {/* Main content container */}
      <Container className="main-container py-5 my-5">
 {/* Main heading */}
 <motion.div
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="text-center mb-3"
      >
        <h2 className="fw-bold display-5 fw-bold">Recent Conference / Events</h2>
        <hr className="mx-auto" style={{ width: "60%", maxWidth: "200px" }}/>
        <p className="fw-bold">Event:- Central University of Karnataka - 2025</p>
      </motion.div>

        <Row className="h-100 g-0">
          {/* Left Content Section */}
          <Col xs={12} md={6} id="cuk-content">
            <motion.div
              className="content-card"
              initial="hidden"
              animate={isVisible ? "visible" : "hidden"}
              variants={staggerContainer}
            >
              <motion.h3 
                className="event-title text-center"
                variants={fadeInUp}
              >
                International Conference on Earth & Environment in Anthropocene - 2025
              </motion.h3>
              
              <motion.p 
                className="event-date text-center"
                variants={fadeInUp}
              >
                March - 2025 
              </motion.p>
              
              <motion.p 
                className="event-sponsor text-secondary text-center"
                variants={fadeInUp}
              >
                Proudly Co-Sponsored by OlewinGroup
              </motion.p>
              <motion.div variants={fadeInUp}>
                <p className="text-center mb-2">
                  In collaboration with Department of Geology, School of Earth Sciences<br/>
                  <strong>Central University of Karnataka</strong>
                </p>
                <p className="text-center mb-0">
                  <strong>Topic:- Quantum Driven - AI in GeoSciences, Future Tech Innovation</strong>
                </p>
              </motion.div>
              
              <div className="divider"></div>
              
              <motion.div variants={fadeInUp} className="text-center">
                <p className="mb-1">By: <strong>Bandaru Mahesh</strong></p>
                <p className="mb-1"><strong>International Event Sponsor & Core Professor & Founder of Olewin Group</strong></p>
                <p className="mb-3"><strong>IIT Kharagpur & MIT-USA</strong></p>
             
              </motion.div>

              {/* Logos */}
              <motion.div 
              className="d-flex justify-content-center align-items-center mt-3 mb-3"
              variants={fadeInUp}
            >
              {/* <img 
                src="https://myacademyimages.s3.eu-north-1.amazonaws.com/cuk/olewin_bmh.png" 
                alt="Olewin" 
                className="img-fluid me-4" 
                style={{ width: "150px", maxWidth: "120px" }}
              /> */}
              <img 
                src="https://upload.wikimedia.org/wikipedia/en/thumb/a/aa/Central_University_of_Karnataka.svg/1200px-Central_University_of_Karnataka.svg.png" 
                alt="CUK Logo" 
                className="img-fluid mb-3" 
                style={{ height: "80px", width: "80px" }} 
              />
            </motion.div>
            
            <motion.p 
              className="text-center mb-0 mt-3"
              variants={fadeInUp}
            >
                <small><b>&copy; <a href="/copy" className="text-decoration-none">CopyRight</a> | Terms & Conditions</b></small>
              </motion.p>
            </motion.div>
          </Col>

          {/* Right Carousel Section */}
          <Col xs={12} md={6}>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.7 }}
              className="carousel-container"
            >
              <Carousel 
                interval={2500} 
                indicators={true}
                controls={true}
              >
                {images.map((item, index) => (
                  <Carousel.Item key={index}>
                    <img 
                      className="d-block" 
                      src={item.url} 
                      alt="Conference" 
                    />
                  </Carousel.Item>
                ))}
              </Carousel>
            </motion.div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default CukPage;